function registerAlertItems(): void {
  const currentDate = new Date();

  const alerts = document.querySelectorAll<HTMLElement>(`.alert-items > .alert`);

  alerts.forEach(alert => {
    const alertDismissDays = parseInt(alert.dataset.alertDismissDurationDays || '0', 10);
    const alertId = alert.dataset.alertId;
    const alertDismissButtons = alert.querySelectorAll<HTMLElement>(`.alert-dismiss-button`);

    alertDismissButtons.forEach(dismissButton => {
      dismissButton.addEventListener('click', event => {
        setSpacerHeights();
        if (alertDismissDays === 0) {
          // Use session storage for alerts set to dismiss after 0 days
          sessionStorage.setItem(`alert-dismiss-${alertId}`, 'session');
        } else {
          // Use local storage for alerts set to dismiss otherwise, containing date they will no longer be dismissed
          const dismissUntilDate = new Date(currentDate);
          dismissUntilDate.setDate(currentDate.getDate() + alertDismissDays);
          localStorage.setItem(`alert-dismiss-${alertId}`, dismissUntilDate.toISOString());
        }
      });
    });

    // If alert is not dismissible or it is not dismissed in either session nor local storage, then show it
    const dismissible = alert.dataset.alertDismissible === 'true';
    const sessionStorageDismissValue = sessionStorage.getItem(`alert-dismiss-${alertId}`);
    const localStorageDismissUntilDate = new Date(localStorage.getItem(`alert-dismiss-${alertId}`) || null);

    if (!dismissible || (!sessionStorageDismissValue && localStorageDismissUntilDate < currentDate)) {
      alert.classList.add('show');
    }
  });

  setSpacerHeights();
}

// Set the height of alert spacers to the height of the alert to prevent content from being obstructed
function setSpacerHeights(): void {
  const alertSpacers = document.querySelectorAll<HTMLElement>(`.alert-spacer`);
  alertSpacers.forEach(x => {
    const nextElement = x.nextElementSibling as HTMLElement | null;
    if (nextElement) {
      x.style.height = nextElement.offsetHeight + 'px';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  registerAlertItems();
});
